import { render, staticRenderFns } from "./bfcomponent.vue?vue&type=template&id=7a32c178"
import script from "./bfcomponent.vue?vue&type=script&lang=js"
export * from "./bfcomponent.vue?vue&type=script&lang=js"
import style0 from "./bfcomponent.vue?vue&type=style&index=0&id=7a32c178&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports